import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Browser } from '../../legacy'
import $ from 'jquery'
import FontFace from 'aria-viewer/tour/containers/FontFace'
import Title from 'aria-viewer/tour/containers/Title'

const LANDSCAPE = 'LANDSCAPE'
const PORTRAIT = 'PORTRAIT'

class Window extends Component {
    static childContextTypes = {
        width: PropTypes.number,
        height: PropTypes.number,
    }

    constructor(props) {
        super(props)

        this.state = {
            width: 0,
            height: 0,
        }

        this.updateSize = this.updateSize.bind(this)
    }
    componentWillUnmount() {
        $(window).off('resize', this.updateSize)
    }
    // TODO : deprecate this use in context
    // TODO   and use Redux viewportWidth/viewportHeight instead
    getChildContext() {
        return {
            width: this.state.width,
            height: this.state.height,
        }
    }

    updateSize() {
        const width = document.documentElement.clientWidth
        const height = document.documentElement.clientHeight

        //If the keyboard on Android didn't just open but orientation changed
        if (height !== this.state.height && width !== this.state.width && Browser.is('mobile')) {
            this.setState({ width, height })
        }
        //if the browser size changed
        if ((height !== this.state.height || width !== this.state.width) && !Browser.is('mobile')) {
            this.setState({ width, height })
        }
    }
    componentDidMount() {
        this.updateSize()
        $(window).on('resize', this.updateSize)
    }
    render() {
        const size = Math.min(this.state.width || 1, this.state.height || 1)
        const scale = Browser.is('mobile') ? Math.min(1.25, Math.max(0.75, size / 480 / window.devicePixelRatio)) : 1

        return (
            <div
                id="main"
                role="main"
                style={{
                    fontSize: `${scale}em`,
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                }}
            >
                <FontFace />
                <Title />
                {Browser.is('android') && Browser.getVersion() <= 33 ? (
                    <div
                        style={{
                            position: 'absolute',
                            fontSize: '1.2em',
                            top: '50%',
                            left: 0,
                            right: 0,
                            marginTop: -12,
                            color: 'white',
                            textAlign: 'center',
                        }}
                    >
                        Your browser is not supported. Please update to the latest {Browser.recommenedBrowser()}{' '}
                        browser.
                    </div>
                ) : (
                    this.props.children
                )}
            </div>
        )
    }
}

export default Window
